// Customizable Area Start
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

interface Props {
    navigation: any,
    openModal:any,
};

interface S {
  currentTab: number | null;
  unreadCount?: number;
  bottomOffset?: number;
  isBouncing?: boolean;
}

interface SS {}

export default class MobileNavMenuController extends BlockComponent<
  Props,
  S,
  SS
> {
  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    this.state = {
      currentTab: 0,
    };

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    this.updateActiveTab(window.location.pathname);
  }

  updateActiveTab(path: string) {
    const convertedPath = path.toLocaleLowerCase()
    let activeTab = null;
    if(convertedPath.includes("dashboard")) {
      activeTab = 0;
    } else if (convertedPath.includes("messages")) {
      activeTab = 1;
    } else if (convertedPath.includes("automations")) {
      activeTab = 3;
    } else if (convertedPath.includes("notifications")) {
      activeTab = 4;
    }
    this.setState({ currentTab: activeTab });
  }

  handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ currentTab: newValue });

    switch (newValue) {
      case 0:
        if (window.location.pathname.toLowerCase().includes('dashboard')) {
          // Already on Home/Dashboard: scroll to top instead of reload
          const w: any = window as any;
          if (w && typeof w.handleHomeFromReels === 'function') {
            w.handleHomeFromReels();
          } else {
            if (w && typeof w.forceScrollToTop === 'function') {
              w.forceScrollToTop();
            }
            if (w && typeof w.resetToHomeView === 'function') {
              w.resetToHomeView();
            }
            // Final fallback
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          }
        } else {
          this.handleRedirect("Dashboard")
        }
        break;
      case 1:
        this.handleRedirect("Messages")
        break;
        case 2:
          console.log("here prees 2");
          break;
      case 3:
        this.handleRedirect("ContactsList")
        break;
      case 4:
        this.handleRedirect("Notifications")
        break;
      default:
        break;
    }
  };

  handleRedirect = (path: string) => {
    const msg = new Message(getName(MessageEnum.NavigationMessage));
    msg.addData(getName(MessageEnum.NavigationTargetMessage), path);
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  };
}
// Customizable Area End
